import { ArrowUpRight } from 'lucide-react';

// Distinctions / recognition strip — surfaces the numbers, partnerships, and
// operating footprint that already appear in the Organization schema, so first-
// time visitors get an instant credibility read.
const DISTINCTIONS = [
  {
    stat: '$340M+',
    label: 'Co-branded revenue structured for partners',
  },
  {
    stat: '5',
    label: 'Category-defining case studies (Nike · Mercedes · Delta · Jones Soda · Comisario)',
  },
  {
    stat: '2',
    label: 'Studios — Carlsbad HQ · Nashville AI Lab',
  },
  {
    stat: '27',
    label: 'Cities served across Southern California, Nevada, and Tennessee',
  },
];

const PARTNER_ROSTER = ['NIKE', 'POPPI', 'RHODE', 'BARSTOOL SPORTS', 'JONES SODA', 'MERCEDES-BENZ', 'DELTA'];

export default function AwardsPress() {
  return (
    <section
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/5"
      data-testid="awards-press"
    >
      {/* Section header */}
      <div className="flex items-center gap-4 mb-14 md:mb-20">
        <span className="w-10 h-px bg-[#FF3D2E]" />
        <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/70">06 / AWARDS · PRESS · PROOF</p>
      </div>

      <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-20 md:mb-28">
        {/* Left — editorial statement */}
        <div className="md:col-span-5">
          <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1] tracking-tight text-balance mb-6">
            The receipts,<br />not the reel.
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-md">
            SMG is a working studio, not a case-study farm. Every number below is currently in production
            for a real partner, at real scale, with a real P&amp;L.
          </p>
          <a
            href="mailto:press@smgmediagroup.com?subject=Press%20inquiry%20%E2%80%94%20SMG%20Media%20Group"
            className="inline-flex items-center gap-2 mt-10 text-[11px] tracking-[0.3em] text-white/80 hover:text-[#FF3D2E] transition-colors border-b border-white/20 hover:border-[#FF3D2E] pb-1"
            data-testid="awards-press-inquiry"
          >
            MEDIA / PRESS INQUIRIES <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>

        {/* Right — distinction grid */}
        <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10">
          {DISTINCTIONS.map((d) => (
            <div
              key={d.stat}
              className="bg-black p-8 md:p-10 flex flex-col justify-between min-h-[180px] md:min-h-[220px] group hover:bg-neutral-950 transition-colors"
              data-testid={`distinction-${d.stat.replace(/[^a-z0-9]/gi, '').toLowerCase()}`}
            >
              <p className="font-display text-white text-5xl md:text-6xl lg:text-7xl leading-none tracking-tight group-hover:text-[#FF3D2E] transition-colors">
                {d.stat}
              </p>
              <p className="text-white/55 text-sm md:text-[15px] leading-snug mt-6">{d.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Partner roster marquee */}
      <div className="border-t border-white/10 pt-10 md:pt-14">
        <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/45 mb-6">
          — CURRENT &amp; PAST PARTNER ROSTER
        </p>
        <div className="flex flex-wrap gap-x-8 gap-y-4 md:gap-x-14">
          {PARTNER_ROSTER.map((p) => (
            <span
              key={p}
              className="font-display text-white/70 text-lg md:text-2xl tracking-[0.15em] hover:text-white transition-colors"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
